<template>
  <div :class="classes" class="trade-history">
    <!-- :empty-message="$t('aacnew.notrades')" -->
    <trade-top-heading-block
      class="
        trade-history__title
        txt--color-04 txt--14px txt--height-18px txt--weight-500 pb-10 pt-10 pl-12 pr-12 bor--bottom bor--transp-02
      "
    >
      <span v-text="$t('trade.marketHistory')" />
    </trade-top-heading-block>
    <exc-table
      :heading="columns"
      :rows="rows"
      :loading="loading"
      disable-striped-rows
      :empty-message="$t('trade.noData')"
      cell-size="s"
      class="trade-history__table"
    >
      <template #td-amount="{ amount }">
        <span class="txt--color-03">{{ amount.value }}</span>
      </template>
      <template #td-createdAt="{ createdAt }">
        <span class="txt--color-03">{{ createdAt }}</span>
      </template>
    </exc-table>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { ExcTable } from '@/components/common'
import { uiKitSizes } from '@/lib/utils'
import { Decimal } from 'decimal.js-light'
import { TRADE_TYPE } from '@/lib/constants'

export default {
  name: 'TradeHistory',
  components: {
    ExcTable,
    TradeTopHeadingBlock: () =>
      import(
        /* webpackMode: "eager" */ '@/components/trade/TradeTopHeadingBlock.vue'
      ),
  },
  props: {
    hideTitleBreakpoint: {
      type: String,
      validator: v => [...uiKitSizes, '', '1366px'].includes(v),
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      tradeHistory: 'trade/tradeHistory',
      amountCurrency: 'pairs/amountCurrency',
      totalCurrency: 'pairs/totalCurrency',
      getCurrentPairName: 'pairs/getCurrentPairName',
    }),
    ...mapState({
      loading: state => state.pairs.fetchStatus === 'loading',
      // pairName: state => state.pairs.currentPair,
    }),
    pairName () {
      return this.getCurrentPairName
    },
    columns () {
      return {
        price: {
          value: this.$t('trade.ordersContainer.price', {
            total: (this.totalCurrency && ` (${this.totalCurrency})`) || '',
          }),
          class: 'txt--right',
        },
        amount: {
          value: this.$t('trade.ordersContainer.amount', {
            amount: (this.amountCurrency && ` (${this.amountCurrency})`) || '',
          }),
          // hideOnMobile: true,
        },
        createdAt: {
          value: this.$t('trade.orders.time'),
          hideOnMobile: true,
        },
      }
      // return [
      //     {
      //         value: this.$t("orders.time"),
      //         widthClass: "TradeHistory__cell is-time",
      //     },
      //     {
      //         value: "",
      //         widthClass: "TradeHistory__cell is-tradeType",
      //     },
      //     this.$t("home.ordersContainer.price", {
      //         total:
      //         (this.totalCurrency && ` (${this.totalCurrency})`) || "",
      //     }),
      //     this.$t("home.ordersContainer.amount", {
      //         amount:
      //             (this.amountCurrency && ` (${this.amountCurrency})`) ||
      //             "",
      //     }),
      // ];
    },
    rows () {
      return this.tradeHistory.map(
        ({ createdAt, amount, price, tradeType }) => ({
          createdAt,
          price: {
            value: +price > 100 ? new Decimal(price).toFixed(3) : price,
            class: [
              'txt--right txt--left--l',
              tradeType.toLowerCase() === TRADE_TYPE.BUY
                ? 'txt--green'
                : 'txt--red',
            ],
          },
          amount: {
            value: amount,
          },
        }),
      )
      // return this.tradeHistory.map(
      //     ({ id, createdAt, amount, price, tradeType, time }) => ({
      //         type: tradeType,
      //         time,
      //         key: `${this.pairName}-${tradeType}-${id}`,
      //         class: tradeType,
      //         value: [
      //             createdAt,
      //             tradeType.toUpperCase(),
      //             price,
      //             amount,
      //         ],
      //     })
      // );
    },
    classes () {
      return {
        [`trade-history--${this.hideTitleBreakpoint}`]: this
          .hideTitleBreakpoint,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.trade-history {
  $titleHeight: 40px;
  $laptop-screen: 1366px;
  $breakpoints: xs, s, m, l, xl, '1366px';
  $root: &;

  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;

  @each $bp in $breakpoints {
    &--#{$bp} {
      #{$root}__title {
        display: none;

        @include bp($bp) {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
    }
  }

  &__title {
    @include bp($laptop-screen) {
      max-height: toRem(45px);
    }
  }

  // &__title {
  //     display: none;

  //     @include bp(1366px) {
  //         display: flex;
  //         // height: toRem(41px);
  //         justify-content: space-between;
  //     }
  // }

  &__table {
    flex: 1;
    overflow: hidden;

    &::v-deep {
      td,
      th {
      }
    }

    &::v-deep .exc-table__cell-price {
      text-align: left;
    }
  }

  &::v-deep {
    th:last-child {
      text-align: right;

      @include bp(l) {
        text-align: left;
      }
    }
  }
}
</style>
